
import * as defaultImport from "@splunk/splunk-utils/fetch";
export * from "@splunk/splunk-utils/fetch";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
